module.exports = __webpack_public_path__ + "media/images/png/save-money-bf2312d447cd6ee383f1551d27841bb9.png";